import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import allRoutes from "client/constants/allRoutes";

const SuperAdminGuard = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to={allRoutes.login} replace />;
  }

  if (user?.RoleId !== 1) {
    return <Navigate to={allRoutes.portal} replace />;
  }

  return children;
};

export default SuperAdminGuard;
